import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";

import {
  QueryProvider,
  PolarisProvider,
} from "./components";
import AuthenthicatedApolloProvider from "./components/providers/AuthenticatedApolloProvider";
import {ValidSessionGuard} from "./components/validSessionGuard";

export default function App() {
  // Any .tsx or .jsx files in /pages will become a route
  // See documentation for <Routes /> for more info
  const pages = import.meta.glob("./pages/**/!(*.test.[jt]sx)*.([jt]sx)", {eager: true});

  return (
    <PolarisProvider>
      <BrowserRouter>
          <QueryProvider>
            <AuthenthicatedApolloProvider>
                <ValidSessionGuard>
                    <Routes pages={pages} />
                </ValidSessionGuard>
            </AuthenthicatedApolloProvider>
          </QueryProvider>
      </BrowserRouter>
    </PolarisProvider>
  );
}
